module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "check-mark.bb80ee32.svg";